export const LINKS_SET_DATA = "LINKS::SET::DATA"
